import React from 'react';
import DownloadOutlined from "@ant-design/icons/lib/icons/DownloadOutlined";
import './FilePreview.scss'
import {getLanguage, t} from "react-switch-lang";
import {format} from "date-fns";
import deleteImage from "../../app/IncurredRisk/components/img/delete.svg";
import {deleteFile} from "../../services/externalizations/fileUploadService";
import {Toast} from "../../utils/sweetAlert";
import {useUserContext} from "../../contexts/UserContext";

function FilePreview({file, imageUrl = null,fileDownload,removeFile}) {
    const user = useUserContext();
    return (
        <div className={'wrapper'}>
            <div className={'w-100'}>
        <div className={'info w-100'}>
            <div className={'content'}>
                <div>
            <p className={'fileName'}>{file.fileName}</p>
            <span className={'date'}>{format(new Date(file?.createdAt), 'dd.MM.yyyy')}</span>
                </div>
            <DownloadOutlined
                onClick={() => {
                    fileDownload(file?.id,file?.fileName,file?.filePath)
                }}
                className={'downloadIcon'}
            />
                {user?.id === file.createdById &&
                <img className={"deleteIcon"} onClick={() => removeFile(file?.fileName,file?.id)} src={deleteImage} alt={'delete'}/>
                }
                </div>
            <div>
                <p className="author">
                    {t('common.createdBy') + ': ' + file.createdBy}
                </p>
            </div>
        </div>
            </div>

        </div>
    );
}

export default FilePreview;